import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import * as _ from 'lodash';
import { ThirdPartyApp } from '../models/tpa';
import { HttpService } from '../../../../../services/http.service';
import { Constants } from '../../../../../app.constant';
@Injectable()
export class TpaService extends HttpService {
  public tpa: ThirdPartyApp;
  //public editdata: ThirdPartyApp = <ThirdPartyApp>{};
  public tpaObject:ThirdPartyApp = <ThirdPartyApp>{};

  setObject(obj){
    this.tpaObject=obj;
  }

  getObject(){
    return this.tpaObject;
  }

  getTpaList(): Observable<ThirdPartyApp[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/tpapp', requestOptionsArgs, 'tpa')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  
  addTpa(tpa: object): Observable<boolean> {
    tpa = _.assignIn({}, tpa);
    let requestOptionsArgs = { body: tpa };
    return this.postApi('/tpapp', requestOptionsArgs, 'tpa')
      .map(res => <ThirdPartyApp>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  editTpa(tpaId: number, tpaObj: object): Observable<boolean> {
    tpaObj = _.assignIn({}, tpaObj);
    let requestOptionsArgs = { body: tpaObj };
    return this.putApi('/tpapp/' + tpaId, requestOptionsArgs, 'tpa')
      .map(res => <ThirdPartyApp>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  resettpaObject() {
    this.tpaObject = <ThirdPartyApp>{};
  }

  deleteTpa(tpaId: any,doValidation?:boolean): Observable<boolean> {
    let requestOptionsArgs =  {};
    if(!doValidation){
      requestOptionsArgs = { search : {'do-validation': doValidation} };  
    }
    return this.deleteApi('/tpapp/' + tpaId, requestOptionsArgs, 'tpa')
      .map(res => {
        this.response = res.json() && res.json();
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // /tpa/reports
  getTpaReportsForMenu(): Observable<ThirdPartyApp[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/tpa/reports', requestOptionsArgs, 'tpa')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getTpaAppOs(): Observable<ThirdPartyApp[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/tpapp/os', requestOptionsArgs, 'tpaOs')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

}



// customer Id in header
/* let token = Constants.userAuthorisedToken();
    let custId = Constants.CurrentCustomerInfomations(customerId);
    let head = { 'Content-Type': 'application/json' };
    if (token) {
      head['Authorization'] = `Bearer ${token}`;
      
    }
    if (customerId) {
      head['customerId'] = customerId;
    }
    let headers = new Headers(head);
    var options = new RequestOptions({ headers: headers });*/


// WEBPACK FOOTER //
// ./src/app/pages/general/components/third-party-app/services/tpa.service.ts